export const titleCase = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const upperCase = (str) => {
  return str.toUpperCase();
}

export const updatePharmacyPOSAfterLicenseUpgrade = (
  existingPharmacyPOS,
  licenseResponseData
) => {
  return {
    ...existingPharmacyPOS,

    licenseKey: licenseResponseData.licenseKey,
    licenseToken: licenseResponseData.token,
    planId: licenseResponseData.plan.id,

    planDetail: {
      id: licenseResponseData.plan.id,
      name: licenseResponseData.plan.name,
      productType: licenseResponseData.plan.productType,
      features: licenseResponseData.plan.features
    },

    updatedAt: new Date().toISOString()
  };
};


export const formatDate = (dateString) => {
  if (!dateString) return "N/A";
  const date = new Date(dateString);
  const day = date.getDate().toString().padStart(2, '0');
  const month = date.toLocaleString(undefined, { month: 'short' });
  const year = date.getFullYear();
  return `${day} ${month} ${year}`; // Example: May 07, 2025
};


/**
 * Check if a feature is enabled in the user's plan
 * @param {string|string[]} featureKey - The feature key(s) to check
 * @param {object} features - The features object from decoded token (flat structure)
 * @returns {boolean} - True if feature is enabled
 */
export const isFeatureEnabled = (featureKey, features) => {
  if (!features || !featureKey) return false;

  // OR condition for multiple features
  if (Array.isArray(featureKey)) {
    return featureKey.some(key => isFeatureEnabled(key, features));
  }

  const featureValue = features[featureKey];

  // ✅ Boolean feature
  if (typeof featureValue === "boolean") {
    return featureValue === true;
  }

  // ✅ Tiered feature: reporting_level
  if (featureKey === "reporting_level") {
    return featureValue === "advanced";
  }

  return false;
};

/**
 * Filter menu items based on feature availability
 * @param {array} menuItems - The menu items to filter
 * @param {object} features - The features object from decoded token (flat structure)
 * @returns {array} - Filtered menu items
 */
export const filterMenuItems = (menuItems, features) => {
  if (!menuItems) return [];

  return menuItems
    .map(section => ({
      ...section,
      Items: section.Items
        ? section.Items.filter(item => {
          // If no featureKey is specified, always show
          if (!item.featureKey) {
            return true;
          }

          // Check if feature is enabled
          return isFeatureEnabled(item.featureKey, features);
        })
          .map(item => {
            // Also filter children if they exist
            if (item.children && item.children.length > 0) {
              return {
                ...item,
                children: item.children.filter(child => {
                  // If no featureKey, show it
                  if (!child.featureKey) {
                    return true;
                  }
                  return isFeatureEnabled(child.featureKey, features);
                })
              };
            }
            return item;
          })
        : []
    }))
    .filter(section => section.Items && section.Items.length > 0); // Remove empty sections
};


// accept only numbers
export const acceptOnlyPositiveNumbers = (e) => {
  if (["e", "E", "+", "-"].includes(e.key)) {
    e.preventDefault();
  }
  if (e.target.value < 0) {
    e.target.value = 0;
  }
};
